import { useState } from 'react';
import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { Box, FilterButton, Menu } from '@pocketlaw/tetris';
import { ToggleTabs, ToggleTabsButton, ToggleTabsButtonsContainer, ToggleTabsContent } from 'shared/domains/common-ui';
import { MenuSingleSelectItem } from 'shared/domains/common-ui/SearchableMenu';
import { CustomOffset } from './CustomOffset';
import { formatSearchDateTimeFilter } from './formatDateMathOffset';
import { searchDateTimeFilterFuturePreset, searchDateTimeFilterPastPreset } from './presets';
import { useFilter } from '../../useFilter';
import { Spacer } from './styled';
export function RelativeDate(props) {
    const { name } = props;
    const filter = useFilter(name);
    const [open, setOpen] = useState(!filter.hasValue);
    const [tab, setTab] = useState('preset');
    const selectedValue = filter.value;
    const appearance = filter.isTouched ? 'draft' : 'default';
    const closeMenu = () => setOpen(false);
    const toggleMenu = () => setOpen(!open);
    const applyValue = (newValue) => {
        if (!newValue) {
            return;
        }
        filter.applyValue(newValue);
        closeMenu();
    };
    const isActive = (preset) => JSON.stringify(preset) === JSON.stringify(selectedValue);
    const selectedLabel = formatSearchDateTimeFilter(filter.value);
    const fallbackLabel = t({
        message: 'Select date',
        comment: 'Search filter: Relative date filter',
    });
    return (<Menu.Root open={open} onClose={closeMenu} maxWidth="unset" target={<FilterButton appearance={appearance} onClick={toggleMenu}>
          {selectedLabel || fallbackLabel}
        </FilterButton>}>
      <ToggleTabs activeTab={tab} onSelectTab={(id) => setTab(id)}>
        <Box px="md" pt="md" style={{ minWidth: '17rem' }}>
          <ToggleTabsButtonsContainer stretch size="small">
            <ToggleTabsButton tabKey="preset">
              <Trans comment="Documents label">Preset</Trans>
            </ToggleTabsButton>
            <ToggleTabsButton tabKey="from-now">
              <Trans comment="Templates label">Relative</Trans>
            </ToggleTabsButton>
          </ToggleTabsButtonsContainer>
        </Box>

        <ToggleTabsContent tabKey="from-now">
          <CustomOffset initialValue={selectedValue} applyValue={applyValue}/>
        </ToggleTabsContent>

        <ToggleTabsContent tabKey="preset">
          <Spacer />

          {searchDateTimeFilterPastPreset.map((preset) => (<MenuSingleSelectItem key={JSON.stringify(preset)} onClick={() => applyValue(preset)} selected={isActive(preset)}>
              {formatSearchDateTimeFilter(preset)}
            </MenuSingleSelectItem>))}

          <Menu.Divider />

          {searchDateTimeFilterFuturePreset.map((preset) => (<MenuSingleSelectItem key={JSON.stringify(preset)} onClick={() => applyValue(preset)} selected={isActive(preset)}>
              {formatSearchDateTimeFilter(preset)}
            </MenuSingleSelectItem>))}
        </ToggleTabsContent>
      </ToggleTabs>
    </Menu.Root>);
}
